import { Component } from '@angular/core';

@Component({
  selector: 'ze-not-found',
  standalone: false,
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css',
})
export class NotFoundComponent {}
